import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseToastComponent } from '../../../@commons/ui-components/toast-popup/base-toast-component';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { CheckIconComponent } from '../../../@icons/check-icon.component';
import { CloseIconComponent } from '../../../@icons/close-icon.component';

@Component({
  selector: 'vw-confirm-toast',
  imports: [
    SharedModule,
    TranslateModule,
    CheckIconComponent,
    CloseIconComponent
  ],
  templateUrl: './confirm-toast.component.html',
  styleUrl: './confirm-toast.component.scss',
})
export class ConfirmToastComponent extends BaseToastComponent {
  @Input() confirmMessage: string;
  @Input() confirmYes: string;
  @Input() confirmNo: string;

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();



}
